import * as React from "react";
import { 
    List,
    Datagrid, Filter, TopToolbar, ExportButton,
    TextField, FunctionField,
    ReferenceInput, SelectInput,
    useRecordContext
} from 'react-admin';
import { useMediaQuery, makeStyles } from '@material-ui/core';
import get from 'lodash/get';
import Config from "../../providers/configProvider";
import LogoField from '../../components/LogoField';

const CompetitionSeasonAndTeamFilter = props => {
    const isSmall = useMediaQuery(theme => theme.breakpoints.down('sm'));
    return (
        <Filter {...props} style={{marginTop: isSmall ? '0px' : '-16px'}}>
            <ReferenceInput label="Comp Season" source="competitionSeasonId" reference="competition-season" filter={{ competitionCode: 'NRL' }} perPage={1000} alwaysOn>
                <SelectInput optionText={record => `${record.name} ${record.seasonYear}`} />
            </ReferenceInput>
            <ReferenceInput label="Team" source="teamId" reference="team" perPage={1000} alwaysOn>
                <SelectInput optionText={<LogoField type="teams" source="code" text="name" />} disabled={!props.enableTeam} />
            </ReferenceInput>
        </Filter>
    );
};

const ListActions = () => (
    <TopToolbar>
        <ExportButton />
    </TopToolbar>
);

const useStyles = makeStyles({
    cellLeft: {
        textAlign: 'left',
        whiteSpace: 'nowrap'
    },
    cellContainer: {
        lineHeight: 1.25
    },
    cellSubtext: {
        fontSize: '.9em',
        color: 'gray'
    }
});

/*** TEAM LINE-UPS ***/
const PlayerField = props => {
    const { source, } = props;
    const classes = useStyles();
    const record = useRecordContext(props);
    const data = get(record, source);
    const isSmall = useMediaQuery(theme => theme.breakpoints.down('sm'));

    if (data) {
        return (
            <div className={classes.cellContainer}>
                <div className={classes.cellLeft}>{isSmall ? data.firstName[0] : data.firstName}{isSmall ? '.' : ' '}{data.lastName}{data.captain ? ' (c)' : ''}</div>
                <div className={classes.cellSubtext}>{data.location}</div>
            </div>
        );
    }
    else
        return '-';
}

export const TeamLineupsList = props => {
    const isSmall = useMediaQuery(theme => theme.breakpoints.down('sm'));
    const classes = useStyles();
    return (
        <List {...props} 
            bulkActionButtons={false}
            filters={<CompetitionSeasonAndTeamFilter enableTeam={false} />}
            filterDefaultValues={{ competitionSeasonId: Config.CurrentCompetitionSeasonId, teamId: Config.MyTeamId }}
            actions={<ListActions />}
            pagination={null}
        >
            {isSmall ? (
                <Datagrid classes={{ rowCell: classes.cellLeft, headerCell: classes.cellLeft }}>
                    <TextField source="roundNumber" label="Rd" />
                    <FunctionField label="Opponent (Result)" render={record => <LogoField type="teams" source="opponentCode" text="opponentCode" additionalText={`(${record.result} ${record.score})`} label="Opp" /> } />
                    <PlayerField label="FB" source="fullback" sortable={false} />
                    <PlayerField label="W1" source="wing1" sortable={false} />
                    <PlayerField label="C1" source="centre1" sortable={false} />
                    <PlayerField label="C2" source="centre2" sortable={false} />
                    <PlayerField label="W2" source="wing2" sortable={false} />
                    <PlayerField label="5/8" source="fiveEighth" sortable={false} />
                    <PlayerField label="HB" source="halfback" sortable={false} />
                    <PlayerField label="P1" source="prop1" sortable={false} />
                    <PlayerField label="DH" source="dummyHalf" sortable={false} />
                    <PlayerField label="P2" source="prop2" sortable={false} />
                    <PlayerField label="2R1" source="secondRow1" sortable={false} />
                    <PlayerField label="2R2" source="secondRow2" sortable={false} />
                    <PlayerField label="L" source="lock" sortable={false} />
                    <PlayerField label="I1" source="interchange1" sortable={false} />
                    <PlayerField label="I2" source="interchange2" sortable={false} />
                    <PlayerField label="I3" source="interchange3" sortable={false} />
                    <PlayerField label="I4" source="interchange4" sortable={false} />
                    <PlayerField label="I5" source="interchange5" sortable={false} />
                    <PlayerField label="I6" source="interchange6" sortable={false} />
                    <PlayerField label="S" source="substitute" sortable={false} />
                </Datagrid>
            ) : (
                <Datagrid classes={{ rowCell: classes.cellLeft, headerCell: classes.cellLeft }}>
                    <TextField source="roundName" label="Round" sortable={false} />
                    <FunctionField render={record => record.competitionCode === 'NRL' 
                        ? <LogoField type="teams" source="opponentCode" text="opponentNickname" /> 
                        : <LogoField type="teams" source="opponentCode" text="opponentName" />
                    } label="Opponent" sortable={false} />
                    <TextField label="Result "source="result" sortable={false} />
                    <PlayerField label="Fullback" source="fullback" sortable={false} />
                    <PlayerField label="Wing 1" source="wing1" sortable={false} />
                    <PlayerField label="Centre 1" source="centre1" sortable={false} />
                    <PlayerField label="Centre 2" source="centre2" sortable={false} />
                    <PlayerField label="Wing 2" source="wing2" sortable={false} />
                    <PlayerField label="Five-Eighth" source="fiveEighth" sortable={false} />
                    <PlayerField label="Halfback" source="halfback" sortable={false} />
                    <PlayerField label="Prop 1" source="prop1" sortable={false} />
                    <PlayerField label="Dummy Half" source="dummyHalf" sortable={false} />
                    <PlayerField label="Prop 1" source="prop2" sortable={false} />
                    <PlayerField label="Second Row 1" source="secondRow1" sortable={false} />
                    <PlayerField label="Second Row 2" source="secondRow2" sortable={false} />
                    <PlayerField label="Lock" source="lock" sortable={false} />
                    <PlayerField label="Interchange 1" source="interchange1" sortable={false} />
                    <PlayerField label="Interchange 2" source="interchange2" sortable={false} />
                    <PlayerField label="Interchange 3" source="interchange3" sortable={false} />
                    <PlayerField label="Interchange 4" source="interchange4" sortable={false} />
                    <PlayerField label="Interchange 5" source="interchange5" sortable={false} />
                    <PlayerField label="Interchange 6" source="interchange6" sortable={false} />
                    <PlayerField label="Substitute" source="substitute" sortable={false} />
                </Datagrid>
            )}
        </List>
    );
};
